import { Location } from 'history';
import React from 'react';
import { connect, MapStateToProps } from 'react-redux';
import { match, Redirect, Route, RouteComponentProps, Switch } from 'react-router';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { SimulationSubspaceName } from '~src/spacesPlatform/state/SpaceInfo';

import { SessionSiteSelectors } from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { RouterError } from '../../bootstrap/routerHelpers/RouterError';
import { SimulationSpaceProvider } from './SimulationSpaceProvider';

export interface SimulationRouteParams {
  readonly id: string;
}

export interface SimulationRouteComponentProps extends RouteComponentProps<SimulationRouteParams> {
  readonly match: match<SimulationRouteParams>;
  readonly location: Location;
}

export interface SimulationSpaceRouterOwnProps {
  readonly siteName: string;
  readonly previousUrl: string;
  readonly urls: SpacesSiteUrls;
}

export interface SimulationSpaceRouterStateProps {
  readonly isRequestAccessEnabled: boolean;
}

export type SimulationSpaceRouterProps =
  SimulationRouteComponentProps &
  SimulationSpaceRouterOwnProps &
  SimulationSpaceRouterStateProps;

export class SimulationSpaceRouterComponent extends React.Component<SimulationSpaceRouterProps, {}> {
  public render() {
    return (
      <Switch>
        <Route exact path={this.props.urls.simulationPath(':id')} render={(routeProps: SimulationRouteComponentProps) =>
          <Redirect to={this.props.urls.simulationOverviewPath(routeProps.match.params.id)} />
        } />
        <Route exact path={this.props.urls.simulationOverviewPath(':id')} render={this.spaceProviderFor('overview')} />
        <Route render={() => <RouterError errorType={'default'} urls={this.props.urls} />} />
      </Switch>
    );
  }

  private spaceProviderFor = (subplace: SimulationSubspaceName): (routeProps: SimulationRouteComponentProps) => JSX.Element => {
    return (routeProps: SimulationRouteComponentProps) => {
      return (
        <SimulationSpaceProvider
          siteName={this.props.siteName}
          simulationId={routeProps.match.params.id}
          siteUrls={this.props.urls}
          subplaceName={subplace}
          routeLocationSearch={routeProps.location.search}
          routeLocationPath={routeProps.location.pathname}
          isRequestAccessEnabled={this.props.isRequestAccessEnabled}
        />
      );
    };
  };
}

const mapStateToProps: MapStateToProps<SimulationSpaceRouterStateProps, SimulationSpaceRouterOwnProps, {}> = (state: AppState) => ({
  isRequestAccessEnabled: SessionSiteSelectors.isRequestAccessEnabled(state)
});

export const SimulationSpaceRouter: React.ComponentClass<SimulationSpaceRouterOwnProps>
  = connect(mapStateToProps, null, null, { pure: false })(SimulationSpaceRouterComponent);
